import { CategoriaService } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const CategoriaManager = (() => {
    const { handleException } = ResponseExceptionHandlerHelper();
    const buscarPorId = (Id, esLookup, requestTracker) => {
        return CategoriaService.buscarPorId(Id, esLookup, requestTracker).then(
            (res) => {
                if (!res.Success) {
                    handleException(res);
                }
                return res.Data;
            }
        );
    };

    const listado = (where) => {
        return CategoriaService.listado(where).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res;
        });
    };

    const crear = (categoria) => {
        return CategoriaService.crear({
            ...categoria,
            Files: categoria.Img,
        }).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res.Data;
        });
    };

    const actualizar = (categoria) => {
        return CategoriaService.actualizar({
            ...categoria,
            Files: categoria.Img,
        }).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res.Data;
        });
    };

    const exportar = (exportar) => {
        return CategoriaService.exportar(exportar).then((res) => {
            return res;
        });
    };

    return {
        buscarPorId,
        listado,
        crear,
        actualizar,
        exportar
    };
})();
